<script setup>import { ref as _ref } from 'vue';

  const dialog = _ref(null);

  const showModal = () => {
    document.documentElement.classList.add("side-panel-scroll-lock");
    dialog.value.showModal();
  };

  const close = () => {
    dialog.value.close();
  };

  const removeScrollLock = () => {
    document.documentElement.classList.remove("side-panel-scroll-lock");
  };

  defineExpose({
    showModal,
    close,
  });
</script>

<template>
  <dialog ref="dialog" @click="close" @close="removeScrollLock">
    <div class="dialog-content mx-4 has-background-white" @click.stop="() => {}">
      <slot></slot>
    </div>
  </dialog>
</template>

<style lang="scss" scoped>
  @import "~jose_modern/css";

  dialog {
    padding: 0;
    overflow: auto;
    overscroll-behavior: contain;

    width: 100dvw;

    height: 100dvh;
    max-height: 100dvh;

    &:modal {
      height: 100dvh;
      max-height: 100dvh;

      margin-right: 0;

      width: 100vw;
      max-width: 100vw;

      border: none;

      @include tablet {
        max-width: 40vw;
      }

      .dialog-content {
        overflow-y: scroll;
        height: 100dvh;
        max-height: 100dvh;

        @include tablet {
          max-width: 40vw;
        }
      }
    }

    &::backdrop {
      background-color: bulmaRgba($scheme-invert, 0.86);
    }
  }
</style>

<style lang="scss">
  html.side-panel-scroll-lock {
    overflow: hidden;
  }
</style>
